var exports = {
  "k": "x61f99309--a0c4f3--container",
};

module.exports = exports;
